import { defineStore } from 'pinia'

import { SoftwareLicenseCost, SoftwareLicensesService } from '@/client'
import { usePreferenceStore } from '@/stores/preferenceStore'

export const useLicenseStore = defineStore('licenseStore', () => {
  const softwareLicenseCosts = ref<
    Map<string, Record<string, SoftwareLicenseCost>>
  >(new Map())
  const preferenceStore = usePreferenceStore()

  /**
   * SoftwareLicenseService
   */
  async function getSoftwareLicenseCosts({
    applicationId: applicationId,
    useCached = true,
  }: {
    applicationId: string
    useCached?: boolean
  }): Promise<Record<string, SoftwareLicenseCost> | undefined> {
    const isCached = softwareLicenseCosts.value.get(applicationId)
    if (isCached && useCached) return isCached
    else {
      await preferenceStore.getPreferences()

      return SoftwareLicensesService.getSoftwareLicensesCostsForSoftwareApiV1SoftwareSoftwareSoftwareIdLicensesCostsGet(
        {
          softwareId: applicationId,
          targetCurrencyCode: preferenceStore.preferences?.currency_code,
        }
      ).then((response) => {
        softwareLicenseCosts.value.set(applicationId, response)
        return response
      })
    }
  }

  return {
    getSoftwareLicenseCosts,
  }
})
